__turbopack_context__.v({
  "aiLight": "header-module__phVSra__aiLight",
  "header": "header-module__phVSra__header",
  "header-ai-aura-breathe": "header-module__phVSra__header-ai-aura-breathe",
  "header-ai-aura-flash": "header-module__phVSra__header-ai-aura-flash",
  "header-ai-light-done": "header-module__phVSra__header-ai-light-done",
  "header-ai-light-scan": "header-module__phVSra__header-ai-light-scan",
  "header-ai-line-draw": "header-module__phVSra__header-ai-line-draw",
  "header-ai-line-undraw": "header-module__phVSra__header-ai-line-undraw",
  "headerAiActive": "header-module__phVSra__headerAiActive",
});
